export default __webpack_public_path__ + "f50e7244a9615a1094b9ae2a921573ca.png";